module.exports = __webpack_public_path__ + "static/media/sms3.52775e92.png";